import HomeAssumptionsZurichLandlordPage from './HomeAssumptionsZurichLandlordPage';

export default HomeAssumptionsZurichLandlordPage;
